import { Box, Choicebox, HardwareToken, RadioGroup, Smartphone, Text } from '@ksyos/design-system';
import { TwoFactorAuthenticationType } from '@common/enums/twoFactorAuthenticationType';

export type MfaMethodSelectorProps = {
    name?: string;
    onChange: (mfaType: TwoFactorAuthenticationType) => void;
    value?: TwoFactorAuthenticationType;
};

export function MfaMethodSelector({ name = 'mfaType', onChange, value }: MfaMethodSelectorProps) {
    return (
        <RadioGroup
            layout="row"
            name={name}
            onChange={(e) => onChange(e.target.value as TwoFactorAuthenticationType)}
            value={value}
        >
            <Choicebox
                color="secondary"
                flex={1}
                label={
                    <>
                        <Box
                            alignItems="center"
                            as="span"
                            display="flex"
                            height="120px"
                            justifyContent="center"
                            sx={{ mt: 2 }}
                            width="100%"
                        >
                            <Smartphone
                                height="120px"
                                variant="mfa"
                            />
                        </Box>
                        <Text
                            as="span"
                            size="sm"
                            sx={{ display: 'block', mt: 2, textAlign: 'center' }}
                        >
                            verificatieapp op mijn
                        </Text>
                        <Text
                            as="span"
                            fontWeight="medium"
                            size="sm"
                            sx={{ display: 'block', textAlign: 'center' }}
                        >
                            smartphone
                        </Text>
                    </>
                }
                ribbon={{
                    text: 'aanbevolen',
                }}
                value={TwoFactorAuthenticationType.verificationApp}
            />
            <Choicebox
                color="secondary"
                flex={1}
                label={
                    <>
                        <Box
                            alignItems="center"
                            as="span"
                            display="flex"
                            height="120px"
                            justifyContent="center"
                            sx={{ mt: 2 }}
                            width="100%"
                        >
                            <HardwareToken
                                variant="front"
                                width="120px"
                            />
                        </Box>
                        <Text
                            as="span"
                            size="sm"
                            sx={{ display: 'block', mt: 2, textAlign: 'center' }}
                        >
                            ik heb een Ksyos
                        </Text>
                        <Text
                            as="span"
                            fontWeight="medium"
                            size="sm"
                            sx={{ display: 'block', textAlign: 'center' }}
                        >
                            hardware token
                        </Text>
                    </>
                }
                value={TwoFactorAuthenticationType.verificationDevice}
            />
        </RadioGroup>
    );
}
